import { ExamEventDetailsProvider } from '@exam-center/exam-event-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import {
  ProctoringDetailsPageHeader,
  ProctoringDetailsModalProvider,
} from '@exam-center/proctoring-details';
import { useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ProctoringDetailsLayout() {
  const { examCenterCode, examEventId } = useParams(
    '/:examCenterCode/proctoring/exam-events/:examEventId',
  );

  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.PROCTORING.DETAILS.VIEW,
        APP_PERMISSIONS.PROCTORING.REGISTRATION.VIEW,
        APP_PERMISSIONS.PROCTORING.E_KYC.VIEW,
      ]}
      options={{ operator: 'OR' }}
    >
      <ExamEventDetailsProvider examCenterCode={examCenterCode} examEventId={examEventId}>
        <ProctoringDetailsModalProvider>
          <ProctoringDetailsPageHeader />
          <Outlet />
        </ProctoringDetailsModalProvider>
      </ExamEventDetailsProvider>
    </PermissionGuard>
  );
}
